<script setup lang="ts">
/**
 * Footer V2 — Coluna "Links"
 * Estrutura específica do accordion "Informações":
 *   - Título "Links"
 *   - Botão "Contate-nos"
 *   - Botão "Jogo Responsável" (link para /user/account-protection)
 *   - Sub-título "Pagamento" (peso 400, mais leve que título de coluna)
 *   - Logo Pix
 */
defineProps<{
  contactUrl: string;
  contactExternal?: boolean;
}>();

// Rota interna da página de proteção da conta / jogo responsável.
const responsibleGamingUrl = localeLink('/user/account-protection');
</script>

<template>
  <div
    aria-label="Links"
    class="footer-v2-links-column"
    role="navigation"
  >
    <h3 class="footer-v2-links-column__title">Links</h3>

    <FooterV2ContactButton
      :external="contactExternal"
      :to="contactUrl"
    />

    <FooterV2ContactButton
      align="start"
      label="Jogo Responsável"
      :show-icon="false"
      :to="responsibleGamingUrl"
    />

    <h4 class="footer-v2-links-column__subtitle">Pagamento</h4>

    <FooterV2PixLogo :width="64" />
  </div>
</template>

<style scoped lang="scss">
.footer-v2-links-column {
  @apply flex flex-col items-start;
  gap: 12px;

  /* Desktop: gap 24px entre sub-blocos (Contate-nos / Pagamento). */
  @media (min-width: 1024px) {
    width: 134px;
    gap: 24px;
    justify-content: center;
  }

  &__title {
    color: rgba(255, 255, 255, 0.5);
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    margin: 0;

    /* Desktop: título "Links" continua visível acima do Contate-nos
       (conforme print do Figma). Apenas alinha tipografia com as
       outras colunas no desktop (weight 400, igual aos títulos
       de Aposte/Comunidade/Regras). */
    @media (min-width: 1024px) {
      font-weight: 400;
    }
  }

  &__subtitle {
    /* "Pagamento": weight 400 (mais leve que títulos de coluna) */
    color: rgba(255, 255, 255, 0.5);
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin: 0;
    margin-top: 4px;

    /* Desktop: sem margin-top extra (gap 24px do pai já gerencia espaço). */
    @media (min-width: 1024px) {
      margin-top: 0;
    }
  }

  /* Desktop: PixLogo a 70px (Figma) sobrescrevendo o width=64 vindo do mobile.
     :deep necessário pois `.footer-v2-pix-logo` é classe de componente filho. */
  @media (min-width: 1024px) {
    :deep(.footer-v2-pix-logo) {
      width: 70px !important;
      height: auto !important;
    }
  }
}
</style>
